export default {
  driver_performance_events_filters_timeFrame: "Timeframe",
  driver_performance_events_filters_events: "Events",
  driver_performance_events_filters_drivers: "Drivers",
  driver_performance_events_filters_tags: "Tags",
  driver_performance_events_filters_configuring: "Configuring",
  driver_performance_events_filters_status: "Status",
  driver_performance_events_filters_driverDisputed: "Driver Challenged",
  driver_performance_events_filters_events_helpText: "No events with video are available in the last 90 days."
};